import { enUS, heIL } from '@clerk/localizations';
import type { LocalizationResource } from '@clerk/shared/types';

import type { I18n } from 'types/config';

/**
 * מיזוג תרגום Clerk עם מיקרו־קופי FUNNER / Berry.
 * משתמש ב־`{{provider|titleize}}` כפי ש־Clerk מצפה לספקי OAuth.
 */
export function buildClerkLocalization(language: I18n): LocalizationResource {
  if (language === 'en') {
    return {
      ...enUS,
      dividerText: 'or with email',
      formButtonPrimary: 'Continue to FUNNER',
      socialButtonsBlockButton: 'Continue with {{provider|titleize}}',
    };
  }

  return {
    ...heIL,
    dividerText: 'או באמצעות אימייל',
    formButtonPrimary: 'המשך ל-FUNNER',
    socialButtonsBlockButton: 'התחבר באמצעות {{provider|titleize}}',
  };
}
